// App.js
import logo from "./logo.svg";
import "./App.css";
import { Home } from "./container/Home/home";
import { Provider } from "react-redux";
import store from "./Redux/store";
import React, { useState, useEffect } from "react";
import { Modal, Input, Form, Button } from 'antd';

function App() {
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 100); // Show modal after 100ms
    return () => clearTimeout(timer);
  }, []);

  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        console.log('Form Data Submitted:', values);
        setShowModal(false);
        alert('Thanks! We will keep you informed.');
        form.resetFields();
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <Provider store={store}>
      <div className="App">
        <Modal
          title="Stay Informed About Fires"
          open={showModal}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Submit"
          cancelText="No, thanks"
        >
          <Form
            form={form}
            layout="vertical"
            name="userInfoForm"
          >
            <Form.Item
              name="name"
              label="Your Name"
              rules={[{ required: true, message: 'Please enter your name' }]}
            >
              <Input placeholder="Your Name" />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email Address"
              rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}
            >
              <Input placeholder="Email Address" />
            </Form.Item>
            <Form.Item
              name="phone"
              label="Phone Number"
              rules={[{ required: true, message: 'Please enter your phone number' }]}
            >
              <Input placeholder="Phone Number" />
            </Form.Item>
            <Form.Item
              name="location"
              label="Your Location"
              rules={[{ required: true, message: 'Please enter your location' }]}
            >
              <Input placeholder="Your Location" />
            </Form.Item>
          </Form>
        </Modal>
        <Home />
      </div>
    </Provider>
  );
}

export default App;
